import { LAYOUTS, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { closeLoader, goBackAction, goToEmail, goToRepaymentAction, hidePopup, navigation } from "./actions";
import SharedPropsService from "../../../SharedPropsService";
import sharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { getBorrowerProfile, getUserContext, removeUrlWithoutReload, SHOW_NEW_WITHDRAW_FLOW, showEmail } from "../../../configs/utils";
import { LENDER_ID, QUERY_PARAMS, TARGET_PAGES } from "../../../configs/constants";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (height, transactionListData, showEmail, showOutstanding, stepperData, showNewWithdrawFlow, bankCode, bankAccountNumber, showBottomNavBar, platform, isFromRejectedWithdrawal, withdrawalRejectedData, isFromWithdrawalRejection, principalOutStandingAmount, isFromRejectedRepayment) => {
    return {
        layout: {
            id: ROUTE.TRANSACTIONS,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                showNewWithdrawFlow ?
                    { id: 'TransactionScreen', type: WIDGET.TRANSACTION_PAGE_REVAMP } :
                    { id: 'TransactionScreen', type: WIDGET.TRANSACTION_PAGE }
            ]
        },
        datastore: {
            TransactionScreen: {
                height: height,
                data: transactionListData,
                goToEmailAction: {
                    routeId: ROUTE.TRANSACTIONS,
                    type: ACTION.GO_TO_EMAIL,
                    payload: {}
                },
                navigationAction: {
                    routeId: ROUTE.TRANSACTIONS,
                    type: ACTION.NAVIGATION,
                    payload: {}
                },
                showEmail: showEmail,
                showOutstanding: showOutstanding,
                emailLoading: false,
                stepperData: stepperData,
                newWithdrawFlow: showNewWithdrawFlow,
                bankCode,
                bankAccountNumber,
                showBottomNavBar: showBottomNavBar,
                goBackAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.TRANSACTIONS,
                    payload: {}
                },
                platform,
                isFromRejectedWithdrawal: isFromRejectedWithdrawal,
                withdrawalRejectedData: withdrawalRejectedData,
                isFromWithdrawalRejection: isFromWithdrawalRejection,
                goToRepaymentAction: {
                    type: ACTION.GO_TO_REPAYMENT,
                    routeId: ROUTE.TRANSACTIONS,
                    payload: {}
                },
                closeLoaderAction: {
                    type: ACTION.CLOSE_LOADER,
                    routeId: ROUTE.TRANSACTIONS,
                    payload: {}
                },
                principalOutStandingAmount: principalOutStandingAmount,
                isFromRejectedRepayment: isFromRejectedRepayment
            }
        },
    };
};
export const transactionsMFV2 = {
    onLoad: async (_, { target, isFromRejectedWithdrawal, withdrawalRejectedData, isFromWithdrawalRejection, isFromRejectedRepayment }) => {
        const creditStatus = await SharedPropsService.getCreditStatus();
        const height = _.getHeight();
        _.instrumentTrack('TXN_PAGE_VIEWED');
        // const userContextResponse = await _.network.post(
        //     api.userContext,
        //     {},
        //     { headers: await getAppHeader() },
        // )
        await _.setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            isFromRejectedWithdrawal: false,
            isFromRejectedRepayment: false
        });
        // const _user = userContextResponse?.data;
        const _user = await getUserContext(_.network);
        const _creditId = _user?.linkedCredits[0]?.creditId;
        if (_creditId === null || _creditId === undefined) {
            await _.navigateToBase(ROUTE.BORROWER_LANDING_SCREEN);
            return;
        }
        await AsyncStorage.removeItem("target");
        const platform = await sharedPropsService.getAppPlatform();
        if (target && target === TARGET_PAGES.TRANSACTION) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        const borrowerAccountId = _user?.linkedBorrowerAccounts[0]?.accountId;
        const transactionHistoryResponse = await _.network.get(`${api.getTransactionHistory}${borrowerAccountId}`, {
            headers: await getAppHeader()
        });
        const borrowerUserProfile = await getBorrowerProfile(_.network);
        const transactionListData = transactionHistoryResponse?.data[0]?.transactionList;
        // const lenderInfo = await getLenderInfo(_.network);
        const lenderInfo = _user?.linkedCredits[0]?.lendingPartnerId;
        const principalOutStandingAmount = _user?.linkedCredits[0]?.principalOutStandingAmount;
        // const _showEmail = showEmail(lenderInfo?.lenderAccountId);
        // const _showOutstanding = lenderInfo?.lenderAccountId.toLowerCase() !== LENDER_ID?.MIRAE
        const _showEmail = showEmail(lenderInfo);
        const _showOutstanding = lenderInfo.toLowerCase() !== LENDER_ID?.MIRAE;
        let showNewWithdrawFlow = false;
        showNewWithdrawFlow = await SHOW_NEW_WITHDRAW_FLOW();
        const bankCode = borrowerUserProfile?.bankDetails?.bankCode;
        const bankAccountNumber = borrowerUserProfile?.bankDetails?.accountNumber;
        const placedDate = "24th Jan";
        const expectedDate = "6 PM, 16-Dec";
        const stepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Withdrawal request received",
                "verticalDescription": `Placed on ${placedDate}`,
                "order": 0
            },
            {
                "status": "IN_PROGRESS",
                "verticalDisplayName": "Expected transfer by",
                "verticalDescription": `${expectedDate}`,
                "order": 1
            }
        ];
        const showBottomNavBar = await SharedPropsService?.getShowVoltBottomBar();
        return Promise.resolve(template(height, transactionListData, _showEmail, _showOutstanding, stepperData, showNewWithdrawFlow, bankCode, bankAccountNumber, showBottomNavBar, platform, isFromRejectedWithdrawal, withdrawalRejectedData, isFromWithdrawalRejection, principalOutStandingAmount, isFromRejectedRepayment));
    },
    actions: {
        [ACTION.GO_TO_EMAIL]: goToEmail,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.HIDE_POPUP]: hidePopup,
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.GO_TO_REPAYMENT]: goToRepaymentAction,
        [ACTION.CLOSE_LOADER]: closeLoader,
    },
};
